import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const Star = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M9.652 15.244a.5.5 0 0 0-.464 0l-5.056 2.652a.5.5 0 0 1-.725-.528l.968-5.61a.497.497 0 0 0-.146-.444L.153 7.382a.5.5 0 0 1 .275-.855l5.645-.823a.5.5 0 0 0 .377-.275L8.972.28A.5.5 0 0 1 9.87.279l2.52 5.109a.5.5 0 0 0 .373.273l5.657.861a.5.5 0 0 1 .272.854l-4.081 3.938a.497.497 0 0 0-.146.444l.968 5.61a.5.5 0 0 1-.725.528l-5.056-2.652Z"
      fill="currentFill"
    />
  </svg>
));

export default Star;
